<template>
  <b-card>
    <div class="d-flex mb-2">
      <div class="mr-auto"></div>
      <div>
        <b-button size="sm" variant="bagsis" @click="selectFiles()">
          <font-awesome-icon icon="plus" />
          Adicionar Arquivo
        </b-button>
      </div>
    </div>

    <Table
      :items="local_value"
      :fields="fields"
      :view_edit="false"
      :current-page="pagination.current_page"
      :per-page="pagination.per_page"
      @delete="delete_file"
      ref="table_files"
    />

    <b-pagination
      v-model="pagination.current_page"
      :total-rows="local_value.length"
      :per-page="pagination.per_page"
      :filter="filter"
      size="sm"
      class="mt-2"
    ></b-pagination>

    <b-modal
      title="Adicionar Arquivo"
      :id="componentId"
      :ref="componentId"
      size="xl"
      ok-variant="bagsis"
      @ok="addFile"
      :footer-class="footer_class"
    >
      <b-tabs v-model="tabIndex" content-class="mt-3">
        <b-tab title="Adicionar Arquivo" active>
          <TableList
            :show_actions="false"
            :show_select="true"
            :show_btn_novo="false"
            ref="files_selected"
          />
        </b-tab>
        <b-tab title="Criar Arquivo">
          <b-card>
            <Form
              @saved="arquivoCriado"
              :selectFile="true"
              :cancel_link="''"
              @cancel="voltar"
              :multiple="true"
            />
          </b-card>
        </b-tab>
      </b-tabs>
    </b-modal>
  </b-card>
</template>

<script>
import TableList from "@/modules/files/Components/TableList.vue";
import Table from "@/modules/files/Components/TableList/Table.vue";
import Form from "@/modules/files/Components/Form.vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import { generateId } from "@/helpers/functions/generateId";

export default {
  components: {
    TableList,
    Table,
    Form,
  },
  data: () => ({
    filter: null,
    pagination: {
      current_page: 1,
      from: 1,
      last_page: 2,
      per_page: 10,
    },
    tabIndex: 0,
    componentId: null,
  }),
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    local_value: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value;
      },
    },
    fields() {
      let fields = [];
      fields.push({ key: "legenda", label: "Legenda" });
      fields.push({ key: "path", label: "Path" });
      fields.push({ key: "categoria.nome", label: "Categoria" });
      fields.push({ key: "outros", label: "#", class: "text-center" });
      fields.push({ key: "actions", label: "", class: "cell-actions" });
      return fields;
    },
    footer_class() {
      if (this.tabIndex == 1) {
        return "d-none";
      }
      return "";
    },
  },
  methods: {
    ...mapActions("files", ["ActionNewFile"]),

    addFile(evt) {
      evt.preventDefault();
      let files = this.$refs.files_selected.getSelected();

      if (files) {
        files.forEach((file) => {
          let index = _.find(this.local_value, { id: file.id });
          if (!index) {
            this.local_value.push(file);
          }
        });
      }

      this.$nextTick(() => {
        this.$bvModal.hide(this.componentId);
      });
    },
    selectFiles() {
      this.$bvModal.show(this.componentId);
    },
    delete_file(file) {
      this.local_value = this.local_value.filter((item) => item.id != file.id);
    },
    arquivoCriado(files) {
      if (files) {
        files.forEach((file) => {
          let index = _.find(this.local_value, { id: file.id });
          if (!index) {
            this.local_value.push(file);
          }
        });
      }
      this.voltar(); // 2
      this.ActionNewFile(); // 3
      this.$nextTick(() => {
        this.$bvModal.hide(this.componentId);
      });
    },
    voltar() {
      this.tabIndex = 0; // 2
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
  },
  async created() {
    this.ActionNewFile();
    this.componentId = "modal-arquivo-" + generateId();
  },
};
</script>

<style></style>
